/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGraphQLResponse } from '@/types/graphql';
import { GraphQLClient } from 'graphql-request'
const endpoint = `${process.env.PAYLOAD_URL}/api/graphql`
const client = new GraphQLClient(endpoint)

export async function callGraphQlQuery(query: string) {
  try {
    return await client.request(
      query,
      {},
      {
        Authorization: `users API-Key ${process.env.PAYLOAD_API_KEY}`,
        "CF-Access-Client-Id": process.env.CF_ACCESS_CLIENT_ID_ZT!,
        "CF-Access-Client-Secret": process.env.CF_ACCESS_CLIENT_SECRET_ZT!,
      },
    )
  } catch (error) {
    throw new Error(`GraphQl call failed: ${error}`);
  }
}

export async function getCollectionSpecificFields(collectionCall: string, fields: string, condition = '', limit = 10000, draft = false, page: number = 1) {
  const query = `
  query {
    ${collectionCall}(
      draft: ${draft}
      limit: ${limit}
      page: ${page}
      where: {${condition}}
    ) {
      docs {
        ${fields}
      }
      totalDocs
    }
  }
`
  return await callGraphQlQuery(query)
}

export async function getGlobalSpecificFields(globalCall: string, fields: string, draft = false) {
  const query = `
  query {
    ${globalCall}(
      draft: ${draft}
    ) {
      ${fields}
    }
  }
`
  return await callGraphQlQuery(query)
}

export async function getCollectionSpecificFieldsByVersion(collectionCall: string, fields: string, versionId = '', limit = 1000) {
  const query = `
  query {
    ${collectionCall}(
      limit: ${limit}
      page: 1
      where: {id: { equals: "${versionId}"}}
    ) {
      docs {
        id
        version {
          ${fields}
        }
      }
      totalDocs
    }
  }
`
  return await callGraphQlQuery(query)
}

export async function getAllDocsFromCollection(collectionName: string, fields: string, condition: string = ' _status: { equals: published }') {
  const data: IGraphQLResponse<any, any> = await getCollectionSpecificFields(
    collectionName,
    fields,
    condition,
    0,
    false,
  ) as IGraphQLResponse<any, any>
  return data?.[collectionName]
}
